import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { generatePath, useNavigate } from 'react-router-v7';
import { routePath } from 'rooting/routes';
import { LogoItem } from 'shared/components/LogoItem';
import { StyledComponents, StyledWrapper } from 'shared/components/StyledComponents';
import { fetchData } from './location.utils';
import {
	StyledCenteredDiv,
	StyledLocationItem,
	StyledLocationName,
	StyledLocationsWrapper,
	StyledSelectLocation,
} from './StyledComponents';
import { locationStore } from 'stores/locationStore/locationStore';
import { useState } from 'react';

export const Locations = () => {
	const { t } = useTranslation();
	const { fetchedLocations, userDetails } = fetchData();
	const [selectedLocationId, setSelectedLocationId] = useState('');
	const navigate = useNavigate();

	const handleLocationSelect = (locationId: string) => {
		locationStore.selectLocation(locationId);
		setSelectedLocationId(locationId);
	};

	const handleContinue = () => {
		navigate(generatePath(routePath.alerts, { locationId: locationStore.selectedLocation?.id }));
	};

	return (
		<StyledWrapper>
			<StyledComponents elevation={4}>
				<LogoItem id='locations-logo-wrapper' />
				<div>
					{!!userDetails && (
						<StyledCenteredDiv id='locations-logged-user-label'>{`${t('pages.locations.hello')} ${userDetails?.firstName} ${userDetails?.lastName}`}</StyledCenteredDiv>
					)}
					<StyledSelectLocation>{t('pages.locations.selectLocation')}</StyledSelectLocation>
				</div>
				<StyledLocationsWrapper>
					{fetchedLocations.map((l) => (
						<StyledLocationItem
							key={l.id}
							id={l.id}
							onClick={() => handleLocationSelect(l.id)}
							active={selectedLocationId === l.id}
						>
							<StyledLocationName>{l.name}</StyledLocationName>
						</StyledLocationItem>
					))}
				</StyledLocationsWrapper>
				<StyledCenteredDiv>
					<Button
						variant='contained'
						disabled={!selectedLocationId}
						onClick={handleContinue}
						id='locations-continue-button'
						fullWidth
					>
						{t('common.buttons.continue')}
					</Button>
				</StyledCenteredDiv>
			</StyledComponents>
		</StyledWrapper>
	);
};
